import React, { useState, useEffect } from "react";
import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Typography,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Paper,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import Select from "react-select";
import { DeleteSharp, EditSharp } from "@mui/icons-material";
import Sidebar from "../sidebar/sidebar";
import { companylogo } from "../../assets/images";
import {
  getAllExpensesTypeAPI,
  addExpenseTypeAPI,
  updateExpenseTypeAPI,
  deleteExpenseTypeAPI,
} from "../../service/service";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./Expenses.scss";
import { getSecureItem } from "../../utilsFunctions";

const ExpenseTypes = () => {
  const history = useHistory();
  const loggedinUser = getSecureItem("loggedinUser");

  const indirectCategories = [
    { label: "Travel & Accommodation", value: null },
    { label: "Legal Fees/Dues", value: null },
    { label: "Supplies & Maintenance", value: null },
    { label: "Miscellaneous", value: null },
  ];

  const directCategories = [
    { label: "Interest Paid on Debt", value: null },
    { label: "Salaries and Benefits", value: null },
    { label: "Courier/Postage", value: null },
    { label: "Rent", value: null },
    { label: "Utilities", value: null },
    { label: "Equipment Buying & Leasing", value: null },
    { label: "Depreciation", value: null },
    { label: "Insurance", value: null },
    { label: "Bank Charges", value: null },
    { label: "Advertising and Promotion", value: null },
  ];

  const formattedCategories = [
    ...directCategories.map((item) => ({
      categoryId: item.value,
      color: "#0a2861",
      type: "Direct",
      title: item.label,
      description: "",
      createdByUserId: null,
      updatedByUserId: null,
      companyId: null,
      createdAt: "",
      updatedAt: "",
    })),
    ...indirectCategories.map((item) => ({
      categoryId: item.value,
      color: "#0a2861",
      type: "Indirect",
      title: item.label,
      description: "",
      createdByUserId: null,
      updatedByUserId: null,
      companyId: null,
      createdAt: "",
      updatedAt: "",
    })),
  ];

  const filterArrays = (arr1, arr2) => {
    // Combine both arrays
    const combinedArr = [...arr1, ...arr2];

    // Group by label
    const groupedByLabel = combinedArr?.reduce((acc, current) => {
      acc[current.title] = acc[current.title] || [];
      acc[current.title].push(current);
      return acc;
    }, {});

    // Filter out groups that contain both null and non-null values for the same label
    const filteredArr = Object.values(groupedByLabel).reduce((acc, group) => {
      const hasNull = group.some((item) => item.categoryId == null);
      const hasNonNull = group.some((item) => item.categoryId != null);

      if (hasNull && hasNonNull) {
        // Exclude only null categoryIds if there are non-null categoryIds for the same label
        const nonNullGroup = group.filter((item) => item.categoryId != null);
        acc.push(...nonNullGroup);
      } else {
        // Include the whole group as is
        acc.push(...group);
      }

      return acc;
    }, []);

    return [...new Set(filteredArr)];
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [payload, setPayload] = useState({
    title: "",
    description: "",
    type: "",
  });

  const [toastMsg, setToastMsg] = useState({
    msg: "",
    time: 2000,
    variant: "success",
  });

  const [errors, setErrors] = useState({
    title: "",
    type: "",
  });

  const expensesType = [
    { label: "Direct Expense", value: "Direct" },
    { label: "Indirect Expense", value: "Indirect" },
  ];

  const [categoryId, setCategoryId] = useState(null);
  const [expensesTypeData, setExpensesTypeData] = useState([]);
  const [deleteExpenseTypeModal, setDeleteExpenseTypeModal] = useState(false);
  const [addUpdateModal, setAddUpdateModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const getRandomColor = () => {
    // Generate a random hex color code
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const fetchData = async () => {
    try {
      const companyId = loggedinUser?.companyId;

      const expenseTypesRes = await getAllExpensesTypeAPI(companyId);

      if (expenseTypesRes?.status == 200 && expenseTypesRes?.data) {
        setExpensesTypeData(
          filterArrays(expenseTypesRes.data?.data, formattedCategories)
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (key, value) => {
    setPayload((prev) => ({ ...prev, [key]: value }));
  };

  const handleSaveExpense = async () => {
    const newErrors = {
      title: !payload.title ? "This field is required" : "",
      type: !payload.type ? "This field is required" : "",
    };

    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error != "");

    if (!hasErrors) {
      const userId = loggedinUser?.userId;
      const companyId = loggedinUser?.companyId;

      try {
        const expensePayload = {
          ...payload,
          companyId,
          createdByUserId: userId,
          updatedByUserId: userId,
          color: getRandomColor(),
        };

        const res = isUpdate
          ? await updateExpenseTypeAPI({ ...expensePayload, categoryId })
          : await addExpenseTypeAPI(expensePayload);

        if (res?.data?.status) {
          setAddUpdateModal(false);
          setToastMsg({
            msg: `Expense Type ${isUpdate ? "Updated" : "Added"} Successfully.`,
            time: 3000,
            variant: "success",
          });

          setTimeout(() => {
            handleOpen();
          }, 500);

          setTimeout(() => fetchData(), 1000);
        } else {
          setAddUpdateModal(false);
          setToastMsg({
            msg: `${res.data?.msg}`,
            time: 3000,
            variant: "info",
          });

          setTimeout(() => {
            handleOpen();
          }, 500);

          setTimeout(() => fetchData(), 1000);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleSaveNull = async (data) => {
    const userId = loggedinUser?.userId;
    const companyId = loggedinUser?.companyId;

    try {
      const expensePayload = {
        title: data?.title,
        description: "",
        type: data?.type,
        companyId,
        createdByUserId: userId,
        updatedByUserId: userId,
        color: getRandomColor(),
      };

      const res = await addExpenseTypeAPI(expensePayload);

      if (res?.status == 200) {
        handleEdit(res?.data?.result);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = (data) => {
    setPayload({
      title: data?.title,
      description: data?.description,
      type: data?.type,
    });
    setCategoryId(data.categoryId);
    setIsUpdate(true);
    setAddUpdateModal(true);
  };

  const handleDelete = async () => {
    try {
      const resp = await deleteExpenseTypeAPI(categoryId);

      if (resp.request.status == 422) {
        setToastMsg({
          msg: "This expense type already has transactions.",
          time: 4000,
          variant: "info",
        });

        setTimeout(() => {
          handleOpen();
        }, 500);
      } else {
        setToastMsg({
          msg: "Expense Type Deleted Successfully.",
          time: 3000,
          variant: "success",
        });

        setTimeout(() => {
          handleOpen();
        }, 500);
      }
      setDeleteExpenseTypeModal(false);
      setTimeout(() => fetchData(), 1000);
    } catch (error) {
      console.error(error);
      console.log(error.status);
    }
  };

  return (
    <>
      <Sidebar />

      <Snackbar
        open={open}
        autoHideDuration={toastMsg.time}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={toastMsg.variant}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toastMsg.msg}
        </Alert>
      </Snackbar>

      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        padding={"10px 100px"}
      >
        <img src={companylogo} alt="logo" />
      </Stack>

      <Stack
        className="expensespage"
        spacing={1}
        padding={"10px 20px 10px 100px"}
      >
        <Grid container>
          <Grid item md={6} sm={4}></Grid>
          <Grid item md={3} sm={4} sx={{ padding: "0 10px" }}>
            <Button
              className="muiCustomButton"
              variant="outlined"
              onClick={() => history.push("expenses")}
            >
              View Expenses
            </Button>
          </Grid>
          <Grid item md={3} sm={4} sx={{ padding: "0 10px" }}>
            <Button
              className="GreenBTN"
              variant="filled"
              onClick={() => {
                setPayload({
                  title: "",
                  description: "",
                  type: "",
                });
                setCategoryId(null);
                setIsUpdate(false);
                setAddUpdateModal(true);
              }}
            >
              + Add Expense Type
            </Button>
          </Grid>
        </Grid>

        <Card style={{ marginTop: "10px" }}>
          <div className="tableLaylout">
            <Table aria-label="sticky table" className="table">
              <TableHead>
                <TableRow className="tablHeadRowPayment">
                  <TableCell className="tablHeadCellPayment">Title</TableCell>
                  <TableCell className="tablHeadCellPayment">Type</TableCell>
                  <TableCell className="tablHeadCellPayment">
                    Description
                  </TableCell>
                  <TableCell className="tablHeadCellPayment">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {expensesTypeData?.map((data, i) => {
                  const { title, type, description, categoryId } = data;

                  return (
                    <TableRow key={i} className="tableRow">
                      <TableCell>{title}</TableCell>
                      <TableCell>{type}</TableCell>
                      <TableCell>{description}</TableCell>
                      <TableCell>
                        <Stack direction={"row"} spacing={1}>
                          <IconButton
                            color="primary"
                            aria-label="update"
                            onClick={() =>
                              categoryId
                                ? handleEdit(data)
                                : handleSaveNull(data)
                            }
                          >
                            <EditSharp />
                          </IconButton>
                          {categoryId ? (
                            <IconButton
                              color="error"
                              aria-label="delete"
                              onClick={() => {
                                setCategoryId(categoryId);
                                setDeleteExpenseTypeModal(true);
                              }}
                            >
                              <DeleteSharp />
                            </IconButton>
                          ) : (
                            <IconButton
                              color="error"
                              disabled={true}
                              aria-label="delete"
                              onClick={() => {
                                setCategoryId(categoryId);
                                setDeleteExpenseTypeModal(true);
                              }}
                            >
                              <DeleteSharp />
                            </IconButton>
                          )}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </Card>
      </Stack>

      {/* Delete Expense Modal */}
      <Dialog
        open={deleteExpenseTypeModal}
        onClose={() => setDeleteExpenseTypeModal(false)}
      >
        <DialogTitle>Delete Expense Type</DialogTitle>
        <DialogContent>
          <Typography fontSize={15} variant="h6">
            Are you sure, You want to delete this expense type record?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Stack direction={"row"} spacing={2}>
            <Button
              variant="outlined"
              onClick={() => setDeleteExpenseTypeModal(false)}
            >
              Cancel
            </Button>
            <Button color="error" variant="contained" onClick={handleDelete}>
              Delete
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      {/* Add/Update Modal */}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={addUpdateModal}
        onClose={() => setAddUpdateModal(false)}
      >
        <DialogTitle>{isUpdate ? "Update" : "Add"} Expense Type</DialogTitle>
        <DialogContent>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <Paper elevation={3} sx={{ p: 2, width: "100%" }}>
              <Stack spacing={0.5} marginBottom={1}>
                <Typography variant="body1">
                  Title<span style={{ color: "red", fontSize: 15 }}>*</span>
                </Typography>
                <TextField
                  hiddenLabel
                  value={payload.title}
                  placeholder="Enter Title"
                  onChange={(e) => handleChange("title", e.target.value)}
                  variant="outlined"
                  fullWidth
                />
                {errors.title && (
                  <Typography style={{ color: "red", fontSize: "12px" }}>
                    {errors.title}
                  </Typography>
                )}
              </Stack>
              <Stack spacing={0.5} marginBottom={1}>
                <Typography variant="body1">
                  Type<span style={{ color: "red", fontSize: 15 }}>*</span>
                </Typography>
                <Select
                  options={expensesType}
                  value={expensesType.find(
                    (item) => item.value == payload.type
                  )}
                  placeholder="Select Types"
                  onChange={(e) => handleChange("type", e.value)}
                />
                {errors.title && (
                  <Typography style={{ color: "red", fontSize: "12px" }}>
                    {errors.title}
                  </Typography>
                )}
              </Stack>
              <Stack spacing={0.5} marginBottom={1}>
                <Typography variant="body1">Description</Typography>
                <TextField
                  hiddenLabel
                  value={payload.description}
                  placeholder="Enter Description"
                  onChange={(e) => handleChange("description", e.target.value)}
                  variant="outlined"
                  fullWidth
                />
              </Stack>
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Stack direction={"row"} spacing={2}>
            <Button variant="outlined" onClick={() => setAddUpdateModal(false)}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSaveExpense}>
              {isUpdate ? "Update" : "Add"}
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExpenseTypes;
